import { Card, CardContent, Typography, Box, Chip } from '@mui/material'
import {
  METRICS_SUMMARY_CARD_CHIP_SX,
  METRICS_SUMMARY_CARD_CONTENT_SX,
  METRICS_SUMMARY_CARD_SUBTITLE_SX,
  METRICS_SUMMARY_CARD_SX,
  METRICS_SUMMARY_CARD_TITLE_SX,
  METRICS_SUMMARY_CARD_VALUE_SX
} from '../../style/metricsIndexStyles'

export default function MetricsSummaryCard({
  title,
  subtitle,
  value,
  icon,
  chipLabel,
  chipClass
}) {
  return (
    <Card
      elevation={0}
      sx={METRICS_SUMMARY_CARD_SX}
    >
      <CardContent
        sx={METRICS_SUMMARY_CARD_CONTENT_SX}
      >
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box display="flex" alignItems="center" gap={1.2}>
            {icon}
            <Typography sx={METRICS_SUMMARY_CARD_TITLE_SX}>
              {title}
            </Typography>
          </Box>

          {chipLabel && (
            <Chip
              label={chipLabel}
              size="small"
              className={`poc-status ${chipClass}`}
              sx={METRICS_SUMMARY_CARD_CHIP_SX}
            />
          )}
        </Box>

        {subtitle && (
          <Typography sx={METRICS_SUMMARY_CARD_SUBTITLE_SX}>
            {subtitle}
          </Typography>
        )}

        <Typography sx={METRICS_SUMMARY_CARD_VALUE_SX}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  )
}
